<template>
  <el-dialog
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="删除提示"
  >
    <div>确定删除吗?</div>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="removePost">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import delGroup from "@/maintain/api/device/device-group-manage/delGroup";
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";

export default {
  name: "removeGroupDialog",
  props: {
    removeId: Number,
  },
  mixins: [dialogMixin, resDisposeMixin],
  methods: {
    removePost() {
      delGroup(this.removeId).then((res) => {
        this.resNoDialog({ res });
      });
    },
  },
};
</script>
